import React from 'react';
import { formatTimestamp } from '../util/util';
import { Server } from '../../server/server';
import './BlogCard.css'

interface BlogCardProps {
  data: any;
  category?: string;
  onClick?: Function;
  onEdit?: Function;
}

class BlogCard extends React.Component<BlogCardProps, {}> {

  constructor(props: BlogCardProps) {
    super(props);
  }

  onClick() {
    if(this.props.onClick)
      this.props.onClick(this.props.data);
  }

  onEdit(event:any) {
    event.stopPropagation();
    if(this.props.onEdit)
      this.props.onEdit(this.props.data);
  }

  render() {
    let data   = this.props.data;
    let d      = new Date(data.date);
    let date   = d.toLocaleString(undefined, {month: "short", day: "numeric"});
    let image  = data.image ? data.image : '/blog.png';
    let author = Server.public.getProfile(data.author);

    return (
      <div className="site-page-panel blog-card" onClick={()=>this.onClick()}>
        <img className="blog-card-image" src={image} />

        <div className="site-page-column" style={{rowGap: '5px'}}>
          <div className='site-page-title-text'>{data.title}</div>
          <div>{data.preview}</div>
          <div className="site-page-subtext">{author.name}&nbsp;&#x2022;&nbsp;{date}</div>
        </div>

        {this.props.category != 'community' && this.props.category != 'friends' && this.props.category != 'following' &&
          <div className="blog-card-state">{data.state}</div>
        }
      </div>
    )
  }
}

export default BlogCard;